{
  "MMM Do YYYY, h:mm a": "YYYY年M月D日 H:mm",
  "MMM Do YYYY": "YYYY年M月D日",
  "Wedding": "結婚式",
  "Funeral": "葬儀",
  "Birthday": "誕生日",
  "School": "学校",
  "Sport": "スポーツ",
  "event type|Other": "その他",
  "Audio/video professional": "映像・音響のプロ",
  "Funeral home owner or director": "葬儀社の経営者・責任者",
  "Event planner or venue manager": "イベントプランナー・会場の管理者",
  "Church, pastor, preacher or minister": "教会・牧師・説教者・聖職者",
  "Teacher or school manager": "教員・学校の管理者",
  "Nonprofit or charity": "非営利団体・慈善団体",
  "Live event streamer or producer": "ライブイベントの配信者・制作者",
  "role|Other": "その他",
  "room noun|room": "ルーム",
  "room noun|stage": "ステージ",
  "room noun|track": "トラック",
  "room noun|court": "コート",
  "room noun|field": "フィールド",
  "room noun|hall": "ホール",
  "room noun|camera": "カメラ",
  "Sorry, we need camera roll permissions to make this work!": "申し訳ありませんが、この機能を使うには写真へのアクセス許可が必要です。",
  "Streaming Permissions Required": "配信にはアクセス許可が必要です",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "カメラ、マイク、録画へのアクセスを許可するまで、EventLiveは配信画面を開けません。",
  "Search for an event": "イベントを検索",
  "Schedule your first service": "最初の葬儀の予定を設定しましょう",
  "Create your first event": "最初のイベントを作成しましょう",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "葬儀ごとに、ご家族と共有できる非公開リンクが発行されます。ご家族はアプリやログインなしで、どのデバイスからでも視聴できます。",
  "It looks like you have no events at the moment. Create one to see it here": "現在、イベントはありません。イベントを作成すると、ここに表示されます。",
  "Schedule a Service": "葬儀の予定を設定",
  "Create an Event": "イベントを作成",
  "You have {count} event credit. Each service day uses one.": {
    "other": "{count}クレジットをお持ちです。葬儀1日につき1クレジットを使用します。"
  },
  "You have {count} event credit. Each event day uses one.": {
    "other": "{count}クレジットをお持ちです。イベント1日につき1クレジットを使用します。"
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "other": "前払いイベントが{count}件あります。このイベントに1件を使用します。"
  },
  "Leave": "終了",
  "Keep editing": "編集を続ける",
  "Leave without scheduling the service?": "葬儀の予定を設定せずに終了しますか？",
  "Leave without scheduling the event?": "イベントの予定を設定せずに終了しますか？",
  "Schedule your live fundraiser": "募金ライブ配信の予定を設定",
  "Schedule a service": "葬儀の予定を設定",
  "Schedule your first event": "最初のイベントの予定を設定",
  "Schedule your event": "イベントの予定を設定",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "次に、寄付の受取先として{organization}を確認します。詳細は後から変更できます。",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "次に、寄付の受取先となる団体を選択します。詳細は後から変更できます。",
  "The family gets one private link to watch live or later. You can change the details any time.": "ご家族には、ライブでも後からでも視聴できる非公開リンクが1つ発行されます。詳細はいつでも変更できます。",
  "You can change the details later.": "詳細は後から変更できます。",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "other": "「{title}」と、その{count}件のステージを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "other": "「{title}」と、その{count}件のトラックを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "other": "「{title}」と、その{count}件のコートを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "other": "「{title}」と、その{count}件のフィールドを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "other": "「{title}」と、その{count}件のホールを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "other": "「{title}」と、その{count}台のカメラを削除してもよろしいですか？"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "other": "「{title}」と、その{count}件のルームを削除してもよろしいですか？"
  },
  "Could not delete event": "イベントを削除できませんでした",
  "Are you sure you want to delete {title}?": "「{title}」を削除してもよろしいですか？",
  "This action cannot be undone.": "この操作は取り消せません。",
  "Delete Event": "イベントを削除",
  "Deleting Event...": "イベントを削除しています…",
  "Delete {camera}": "{camera}を削除",
  "How to Go Live": "ライブ配信の方法",
  "Guest List & Invite": "ゲストリストと招待",
  "Title, Date, Time, Event Link, Uploads": "タイトル、日付、時刻、イベントリンク、ファイル",
  "Add Another Camera Angle": "別のカメラアングルを追加",
  "Add a Room, Stage or Track": "ルーム、ステージ、トラックを追加",
  "Chat": "チャット",
  "Privacy Settings": "プライバシー設定",
  "Event Branding": "イベントのブランディング",
  "Event Analytics": "イベントの分析",
  "Expiring soon": "まもなく期限切れ",
  "Storage expiry": "保存期限",
  "You're invited to watch {title}": "「{title}」の配信にご招待します",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "ゲストはメインのリンクからアクセスし、そこでこのカメラに切り替えます。このカメラは専用のスマートフォンから配信してください。",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "このリンクを共有してください。ゲストは視聴中にカメラを切り替えられます。カメラごとに別々のスマートフォンから配信します。",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "ゲストはメインのリンクからアクセスし、イベントページで{noun}を切り替えます。この{noun}は専用のストリームキーで配信します。",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "このリンクを共有してください。ゲストはイベントページで{noun}を切り替えられます。{noun}ごとに専用のストリームキーで配信します。",
  "Your event link:": "イベントリンク：",
  "{days}-day event:  Unlock with {count} more credit": {
    "other": "{days}日間のイベント：あと{count}クレジットでアンロック"
  },
  "Unlock with {count} credit": {
    "other": "{count}クレジットでアンロック"
  },
  "{days}-day event: Unlock with {count} prepaid events": "{days}日間のイベント：前払いイベント{count}件でアンロック",
  "{days}-day event: Unlock with your prepaid event": "{days}日間のイベント：前払いイベントでアンロック",
  "Unlock with {count} prepaid events": "前払いイベント{count}件でアンロック",
  "Unlock with your prepaid event": "前払いイベントでアンロック",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "イベントの非公開リンクは{date}に期限切れになる予定です。イベントページ、動画、ゲストブックを、さらに1年間、または10年間公開しておくことができます。",
  "Keep My Memories Online Longer": "思い出の公開期間を延長",
  "Download & View Stats": "ダウンロード・統計を見る",
  "This Event is in the Secure Archive.": "このイベントは安全なアーカイブに保管されています。",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "このイベントの公開配信期間は終了しました。配信リンクは有効期限が切れましたが、思い出はアーカイブに安全に保管されています。",
  "Restore this Event": "このイベントを復元",
  "Unlock cameras": "カメラをアンロック",
  "{days}-Day Event: {start} – {end}": "{days}日間のイベント：{start}〜{end}",
  "Expires in {count} day": {
    "other": "あと{count}日で期限切れ"
  },
  "Event is in the Secure Archive": "イベントは安全なアーカイブに保管されています",
  "Extend": "延長",
  "Use credit": "クレジットを使用",
  "Use prepaid event": "前払いイベントを使用",
  "Could not unlock the event": "イベントをアンロックできませんでした",
  "Pay As You Go": "都度払い",
  "Couldn't schedule the service": "葬儀の予定を設定できませんでした",
  "Couldn't schedule the event": "イベントの予定を設定できませんでした",
  "Service title": "葬儀のタイトル",
  "e.g. Celebration of Life for Jane Doe": "例：山田花子さんのお別れ会",
  "e.g. Anna & Mark's wedding": "例：健太と美咲の結婚式",
  "your-event-link": "my-event",
  "Available": "利用可能",
  "Event type": "イベントの種類",
  "Choose the type of event": "イベントの種類を選択",
  "When the service starts": "葬儀の開始日時",
  "When the event starts": "イベントの開始日時",
  "Make it a multi-day event": "複数日のイベントにする",
  "Raise donations for a nonprofit": "非営利団体への寄付を募る",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "視聴者はイベントページから寄付できます。寄付先の団体は、イベントの作成後に選択します。",
  "Schedule service": "葬儀の予定を設定",
  "Schedule event": "イベントの予定を設定",
  "Event details": "イベントの詳細",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room}の日付、時刻、日数はメインイベントに連動します。メインイベントで変更すると、すべての{noun}に反映されます。",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "ここでの変更はすべての{noun}に適用されます。追加日の料金は{noun}ごとにかかります。",
  "Title and location": "タイトルと場所",
  "Test events keep their name.": "テストイベントの名前は変更できません。",
  "e.g. St. Mary's Church, Austin": "例：聖マリア教会（東京都）",
  "Links and files": "リンクとファイル",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "イベントページの動画の下に表示されます（ギフトリスト、寄付ページ、ウェブサイト、プログラムなど）。",
  "Event rescheduled": "イベントの日時を変更しました",
  "Guests will see the new date.": "ゲストには新しい日付が表示されます。",
  "Couldn't change the date": "日付を変更できませんでした",
  "Event date and time": "イベントの日時",
  "Choose the event's local date and time": "イベント開催地の日時を選択",
  "Save date and time": "日時を保存",
  "Change Link": "リンクを変更",
  "Change event link?": "イベントリンクを変更しますか？",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "現在のリンクをすでにゲストと共有している場合、ゲストは古いリンクからイベントにアクセスできなくなります。続行してもよろしいですか？",
  "Event link changed": "イベントリンクを変更しました",
  "Couldn't change the link": "リンクを変更できませんでした",
  "Share this link with your guests.": "このリンクをゲストと共有してください。",
  "your-event-name": "my-event",
  "Copy event link": "イベントリンクをコピー",
  "Guests who already have the old link won't be able to open the event with it.": "古いリンクを持っているゲストは、そのリンクからイベントを開けなくなります。",
  "Change link": "リンクを変更",
  "Edit {title}": "「{title}」を編集",
  "Edit link": "リンクを編集",
  "Add a name": "名前を追加",
  "Add a web address": "ウェブアドレスを追加",
  "Open {title}": "「{title}」を開く",
  "Open link": "リンクを開く",
  "Remove {title}": "「{title}」を削除",
  "Remove link": "リンクを削除",
  "File name guests see": "ゲストに表示されるファイル名",
  "Link text": "リンクのテキスト",
  "e.g. Order of service": "例：式次第",
  "e.g. Our registry": "例：ギフトリスト",
  "Web address": "ウェブアドレス",
  "Add link": "リンクを追加",
  "File added": "ファイルを追加しました",
  "Guests can open it from the event page.": "ゲストはイベントページから開けます。",
  "Removed \"{title}\"": "「{title}」を削除しました",
  "Removed \"link\"": "リンクを削除しました",
  "Tap to undo": "タップして元に戻す",
  "Uploading…": "アップロード中…",
  "Upload file": "ファイルをアップロード",
  "file type|Text": "テキスト",
  "file type|Image": "画像",
  "file type|File": "ファイル",
  "Document": "ドキュメント",
  "Add the text guests will see.": "ゲストに表示するテキストを入力してください。",
  "Add the web address.": "ウェブアドレスを入力してください。",
  "Enter an address like zola.com/registry or an email.": "zola.com/registryのようなアドレス、またはメールアドレスを入力してください。",
  "Multi-Day event?": "複数日のイベントですか？",
  "Days": "日数",
  "Timezone: {timezone}": "タイムゾーン：{timezone}",
  "Search timezone...": "タイムゾーンを検索…",
  "Select timezone": "タイムゾーンを選択",
  "MMMM D, yyyy h:mm a": "YYYY年M月D日 H:mm",
  "dddd, MMMM D, YYYY": "YYYY年M月D日(ddd)",
  "ddd, MMM D": "M月D日(ddd)",
  "Start Time": "開始時刻",
  "Event Date and Local Time": "イベントの日付と現地時刻",
  "Event Date": "イベントの日付",
  "Select": "選択",
  "date picker|Choose": "選択",
  "date picker|Not available": "選択できません",
  "date picker|Month": "月",
  "date picker|Previous Month": "前の月",
  "date picker|Next Month": "次の月",
  "EEEE, MMMM d, yyyy": "yyyy年M月d日(EEE)",
  "Start time": "開始時刻",
  "h:mm aa": "H:mm",
  "date picker|time": "時刻",
  "MMMM d, yyyy h:mm aa": "yyyy年M月d日 H:mm",
  "EEE, MMM d": "M月d日(EEE)",
  "Hide the event page? Guests won't be able to open it.": "イベントページを非表示にしますか？ゲストはページを開けなくなります。",
  "Hide the event page?": "イベントページを非表示にしますか？",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "other": "ページを再び表示するまで、チケットを購入した方はライブ配信も録画も視聴できなくなります。ゲストリストの{count}人がアクセスできなくなります。"
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "ページを再び表示するまで、チケットを購入した方はライブ配信も録画も視聴できなくなります。",
  "{days}-Day Event: {start}": "{days}日間のイベント：{start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "このイベントはまだアンロックされていません。{team}のアカウントの管理者にアンロックを依頼してください。",
  "Couldn't load {team}'s events. Try again.": "{team}のイベントを読み込めませんでした。もう一度お試しください。",
  "Switch to my account": "自分のアカウントに切り替える",
  "No events yet": "イベントはまだありません",
  "Events in {team}'s account will show up here.": "{team}のアカウントのイベントがここに表示されます。",
  "Event unlocked": "イベントをアンロックしました",
  "Couldn't unlock this event": "このイベントをアンロックできませんでした",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "{team}のアカウントのクレジットが不足している可能性があります。アカウントの所有者に追加を依頼してください。"
}
